












import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import AnalyticsCardList, {
  AnalyticsCardListItem
} from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';

import PerformanceActivitiesService from '@/api/PerformanceActivitiesService';

@Component({
  components: {
    AnalyticsCardList
  }
})
export default class ActivitiesOverviewSellingCoins extends Vue {
  @Prop() filters!: Record<string, any>;
  @Prop({ default: true }) showRequestLoading?: boolean;

  performanceActivitiesService: PerformanceActivitiesService = new PerformanceActivitiesService();

  analytics: Record<string, AnalyticsCardListItem> = {
    coinsSold: {
      infos: {
        title: 'Coins sold',
        amount: 0,
        tooltipText: '',
        insightText: '',
        counterFractionDigits: 0
      }
    },
    coinsAwarded: {
      infos: {
        title: 'Coins awarded',
        amount: 0,
        tooltipText: '',
        insightText: '',
        counterFractionDigits: 0
      }
    },
    coinsGifted: {
      infos: {
        title: 'Coins gifted',
        amount: 0,
        tooltipText: '',
        insightText: '',
        counterFractionDigits: 0
      }
    }
  };

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tPrefix() {
    return `performance.activities.campaignActivity.tabs.giftCardsCoins`;
  }

  get translatedAnalytics() {
    return Object.entries(this.analytics)
      .map(([key, value]) => ({
        ...value,
        infos: {
          ...value.infos,
          tooltipText: this.$t(`${this.tPrefix}.${key}.tooltip`)
        }
      }))
      .filter(({ hidden }) => !hidden);
  }

  @Watch('filters')
  async getOverview() {
    if (this.showRequestLoading) {
      this.$showLoaderWithLocker();
    }

    let endpointPath = `/v2/admin/transaction/basic-reports`;

    const response = await this.performanceActivitiesService.getActivitiesOverview(
      endpointPath,
      this.filters
    );

    this.$hideLoader();

    if (response.status !== 200) return;

    const { coinsAwarded, coinsGifted, coinsSold } = response.data;

    this.analytics.coinsSold.infos.amount = coinsSold;
    this.analytics.coinsAwarded.infos.amount = coinsAwarded;
    this.analytics.coinsGifted.infos.amount = coinsGifted;
  }

  mounted() {
    setTimeout(() => this.getOverview(), 0);
  }
}
